import { render, staticRenderFns } from "./required-documents.vue?vue&type=template&id=65db54dc"
import script from "./required-documents.vue?vue&type=script&lang=js"
export * from "./required-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports